var isKeyframesTarget = function (v) {
  return Array.isArray(v);
};
export { isKeyframesTarget };